module.exports = __webpack_public_path__ + "img/solution_bg2.19e4cbb.png";